import { render } from "./WalletTopup.vue?vue&type=template&id=28a86932&scoped=true&bindings={\"amount\":\"data\",\"msisdn\":\"data\",\"destination\":\"data\",\"userId\":\"data\",\"error\":\"data\",\"amountValidationError\":\"data\",\"submitForm\":\"options\",\"closeAlert\":\"options\",\"onAmountKeyUp\":\"options\",\"amountHasError\":\"options\",\"showAmountErrors\":\"options\"}"
import script from "./WalletTopup.vue?vue&type=script&lang=js"
export * from "./WalletTopup.vue?vue&type=script&lang=js"

import "./WalletTopup.vue?vue&type=style&index=0&id=28a86932&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-28a86932"

export default script